<template>
  <div class="monthpicker-with-arrow">
    <button
      class="monthpicker-with-arrow__button"
      @click.stop="onClickSubButton">
      <MaterialIcon
        icon="arrow_left" />
    </button>
    <datepicker
      v-model="_value"
      :language="ja"
      placeholder="年月を選択してください"
      :format="format"
      class="monthpicker"
      input-class="monthpicker__input"
      calendar-class="monthpicker__calendar"
      wrapper-class="monthpicker__wrapper"
      minimum-view="month" />
    <button
      class="monthpicker-with-arrow__button"
      @click.stop="onClickAddButton">
      <MaterialIcon
        icon="arrow_right" />
    </button>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import { ja } from 'vuejs-datepicker/dist/locale'
import { addMonths } from 'date-fns'
export default {
  name: 'MonthPickerWithArrow',
  components: {
    Datepicker
  },
  props: {
    value: {
      type: Date,
      default: null
    },
    format: {
      type: String,
      default: 'yyyy年M月'
    }
  },
  data() {
    return {
      ja
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    }
  },
  methods: {
    onClickAddButton() {
      this._value = addMonths(this._value, 1)
    },
    onClickSubButton() {
      this._value = addMonths(this._value, -1)
    }
  }
}
</script>

<style lang="scss">
.monthpicker-with-arrow {
  display: flex;
  align-items: center;

  &__button {
    border: none;
    background-color: transparent;
    color: $primary;
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      font-size: 32px;
    }
  }
}

.monthpicker {
  font-size: 12px !important;
  box-shadow: 1px 2px 6px $grey05;
  text-decoration: none;
  background-color: $primary;
  border-radius: 4px;

  &__input {
    background-color: transparent;
    border: none;
    text-align: center;
    color: $white;

    font-weight: 700;
  }

  &__calendar {
    left: -20px;

    .cell {
      border-radius: 50%;

      &.today {
        background-color: lighten($l-blue, 50%)
      }

      &.selected {
        background-color: $l-blue;
        color: $white;
      }
    }
  }

  &__wrapper {

  }
}

</style>